import { Observable, Subject, of } from 'rxjs';
import { environment } from './../../environments/environment';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./utils.service";
var Manager = require("socket.io-client").Manager;
import { UtilsService } from './utils.service';
var LobbyService = /** @class */ (function () {
    function LobbyService(_utilsService) {
        this._utilsService = _utilsService;
        this.currentGame = new Subject(); // used by game selector component {game,abbr}
        var currentUserDeatail = JSON.parse(localStorage.getItem('currentUser'));
        var jwt = currentUserDeatail && currentUserDeatail.token ? currentUserDeatail.token : "";
        var draftSocket = new Manager("" + environment.draftUrl, { transports: ['websocket'], query: { token: jwt } });
        this.draftSocket = draftSocket.socket("/");
        this.cgObservable = this.currentGame.asObservable();
        this.setCurrentGame({ game: 'all', abbr: 'all', season: '29' });
    }
    LobbyService.prototype.setCurrentGame = function (game) {
        this.currentGame.next(game);
    };
    LobbyService.prototype.updateLeagueMember = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.draftSocket.on('update_league_member', function (res) {
                observer.next(res);
            });
        });
    };
    LobbyService.prototype.updateTournamentMember = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.draftSocket.on('update_tournament_member', function (res) {
                observer.next(res);
            });
        });
    };
    LobbyService.prototype.fillLeagueMember = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.draftSocket.on('remove_filled_league', function (res) {
                observer.next(res);
            });
        });
    };
    LobbyService.prototype.fillTournamentMember = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.draftSocket.on('remove_filled_tournament', function (res) {
                observer.next(res);
            });
        });
    };
    LobbyService.prototype.getLeagues = function (user_id, game) {
        if (game === void 0) { game = 'all'; }
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/fantasyLeague/get-contest/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + game + '/' + user_id);
    };
    LobbyService.prototype.getTournaments = function (user_id, game) {
        if (game === void 0) { game = 'all'; }
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/fantasyLeague/get-contest-tournament/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + game + '/' + user_id);
    };
    LobbyService.prototype.getFilters = function (user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/lobby/get-filters/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id);
    };
    LobbyService.prototype.getGames = function (page_type) {
        if (page_type === void 0) { page_type = ''; }
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/games/listV2/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '?page_type=' + page_type);
    };
    LobbyService.prototype.getDrafted = function () {
        if (localStorage.getItem('draftedToday')) {
            var draftedToday = JSON.parse(localStorage.getItem('draftedToday'));
            if (draftedToday.expires < Date.now()) {
                return this._utilsService.getRequest("" + environment.phpApiUrl + '/lobby/liveLeagues/' + ("" + environment.DRAFT_ACCESS_TOKEN), 'getDrafted');
            }
            else {
                return of({ status: "success", leagues: draftedToday.value }).pipe(map(function (res) { return res; }));
            }
        }
        else {
            return this._utilsService.getRequest("" + environment.phpApiUrl + '/lobby/liveLeagues/' + ("" + environment.DRAFT_ACCESS_TOKEN), 'getDrafted');
        }
    };
    LobbyService.prototype.storeFilters = function (filters, user_id) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            filters: JSON.stringify(filters),
            user_id: user_id
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/lobby/save-filters', data, null, 'content-type-json');
    };
    LobbyService.prototype.getStaticContent = function (slug) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/pages/detail/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + slug);
    };
    LobbyService.ngInjectableDef = i0.defineInjectable({ factory: function LobbyService_Factory() { return new LobbyService(i0.inject(i1.UtilsService)); }, token: LobbyService, providedIn: "root" });
    return LobbyService;
}());
export { LobbyService };
